import { Dialog, DialogContent } from "@mui/material";
import PopupAppBar from "../Common/PopupAppBar";
import BugReportIcon from '@mui/icons-material/BugReport';

import { IActionForProvider } from "../../Lib/Actions/actions";
import { ILogEntries } from "../../Lib/Log/types";
import LogView from "./LogView";


interface LogViewPopupProps {
    action: IActionForProvider<void, void>;
    log: ILogEntries;
};

const LogViewPopup = (props: LogViewPopupProps) => {
    return (
        <Dialog
            fullScreen
            open={props.action.isActive}
            onClose={props.action.cancel}
        >
            <PopupAppBar title="Debug Log" icon={<BugReportIcon/>} onClose={props.action.cancel} showNetworkStatus={true}/>

            <DialogContent>
                <LogView log={props.log} />
            </DialogContent>

        </Dialog>
    );
};

export default LogViewPopup;